import { get } from '@eika-infrastruktur/request';

import { CardAccount } from '../generated-types';
import { CONTEXT_PATH } from './accountService';

export const SERVICE_PATH = 'rest/resource/creditcards';

export const getCreditCardAccounts = async () => get<CardAccount[]>(`${CONTEXT_PATH}/${SERVICE_PATH}`);
